<script>
import Base from '@/plans/CONCURRENCY_MEETING_BASIC/config/base';
import addonMixin from '@/plans/mx/addon';
import currentPlanMixin from '@/plans/CONCURRENCY_MEETING_BASIC/mixin';
import { mapGetters } from 'vuex';
import { DEFAULT_MIN_HOST, DEFAULT_MAX_HOST } from '@/common/constants';
import { get, min, compact } from 'lodash'
import replenishMixin from "@/components/capacity/mx/replenish";
import mx_plansCommon from '@/plans/mx/plan';

export default {
  name: 'ConcurrentMeetingEdit',
  extends: Base,
  inject: ['curPlanType'],
  mixins: [currentPlanMixin, addonMixin, replenishMixin, mx_plansCommon],
  data() {
    return {
      showCycleAlert: false,
      planType: '',
    };
  },
  computed: {
    ...mapGetters(['basicConfig', 'currentEditPlan', 'getCurrentMeetingPlans', 'getCurrentMeetingPlans', 'basePlanTotalLicenses']),
    // data for replenish
    configPlanType() {
      return this.curPlanType
    },
    // data for replenish
    selectedPlanList() {
      return this.getSelectedPlans
    },
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    disabledForBulkLicense() {
      return (cycle) => {
        return this.basicConfig?.isBulkLicenseAccount && this.currentEditPlan?.billing_cycle !== cycle;
      };
    },
    previousQuantity() {
      return this.currentEditPlan?.cartInfo?.selected_number ?? DEFAULT_MIN_HOST;
    },
    minHosts() {
      if (this.disableDownSell || this.decreaseTips) return this.previousQuantity;
      return this.mx_minHosts;
    },
    maxHosts() {
      return this.mx_getMaxHosts;
    },
    disableDownSell(){
      return this.basicConfig.downSellData.disableDownSell;
    },
    decreaseTips() {
      if (this.selectedNumber === this.previousQuantity && this.disableDownSell) {
        return this.$t('billing.error.can_not_bought_plan_tips');
      }

      return this.mx_decreaseTips || this.nonStandardPriceDisableDecreaseTipForTieredPlan;
    },
    editTotalLimitDesc() {
      const basePlanNameKey = get(this.currentBasePlans, [0, 'parentPlanNameKey']) || get(this.currentBasePlans, [0, 'planNameKey']) || get(this.currentBasePlans, [0, 'typeNameKey'])
      return this.$t('billing.addon_license_limit_tips', [this.concurrentMeetingTitle, this.$t(basePlanNameKey)])
    },
    mx_getMaxHosts() {
      const maxQuantityInPlanMap = get(this.planList, [0, 'max'], DEFAULT_MAX_HOST)
      return this.mx_canAutoAdd ? DEFAULT_MAX_HOST : min(compact([this.basePlanTotalLicenses, maxQuantityInPlanMap]))
    },
  },
  watch: {
    selectedNumber: {
      handler() {
        this.$nextTick(() => {
          this.handleLicenseChange(this.selectedNumber);
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleLicenseChange(license) {
      this.mx_validDownSellLicense(license)
      if (license >= this.mx_getMaxHosts && !this.mx_canAutoAdd && this.mx_getMaxHosts !== 999) {
        this.licenseWarningAlertTip = this.editTotalLimitDesc
      } else if (this.mx_downSellLicenseErrorMessage) {
        this.licenseWarningAlertTip = this.mx_downSellLicenseErrorMessage
      } else {
        this.licenseWarningAlertTip = ''
      }
    },
  },
  created() {
    this.planType = this.curPlanType
  }
};
</script>
